import React from 'react';

const SystemTable = ({ systems, searchTerm }) => {
  return (
    <div className="flex-1 min-h-0 overflow-auto">
      <table className="min-w-full">
        <thead className="bg-gray-50 sticky top-0 z-10">
          <tr>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider whitespace-nowrap">
              System ID
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider whitespace-nowrap">
              System Name
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider whitespace-nowrap">
              Description
            </th>
          </tr>
        </thead>

        <tbody className="bg-white divide-y divide-gray-200">
          {systems.length > 0 ? (
            systems.map((system, index) => (
              <tr key={index} className="hover:bg-gray-50">
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                  {system.system_id}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                  {system.system_name}
                </td>
                <td className="px-6 py-4 text-sm text-gray-500 truncate max-w-xs">
                  {system.description}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="3" className="px-6 py-8 text-center text-gray-500">
                {searchTerm ? 'No systems match your search' : 'No systems found'}
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default SystemTable;